import { xhrPath } from '@/xhr/connections.js';
import picador from '@/xhr/connections/picador';

export default {
  async getCitations(documentID) {
    return await picador.get('getCitations', xhrPath.document({ documentID }) + '/citations');
  },

  async addCitation(documentID, citationData) {
    return await picador.post(
      'addCitation',
      xhrPath.document({ documentID }) + '/add_citation',
      citationData
    );
  },

  async viewCitationText(documentID, citationID) {
    return await picador.get(
      'viewCitationText',
      xhrPath.document({ documentID }) + '/citation/' + citationID + '/text'
    );
  },

  async updateCitation(documentID, citationID, citationData) {
    return await picador.put(
      'updateCitation',
      xhrPath.document({ documentID, citationID }),
      citationData
    );
  },

  async loadCitationDocument(debateID, citationID, citationData, documentData) {
    return await picador.post(
      'loadCitationDocument',
      `${xhrPath.debate({ debateID })}/contest_citation/${citationID}`,
      {
        citationData,
        documentData,
      }
    );
  },

  async deleteCitation(documentID, citationID) {
    return await picador.delete('deleteCitation', xhrPath.document({ documentID, citationID }));
  },
};
